









































































































































































import Vue from 'vue'

import {
  GetCompany,
  PatchCompany,
  Company,
  SISPEKConnectionTest,
} from '@/api/cems'

import {
  FindStacks,
  Stack,
  SispekAccount,
  GetSispekAccount,
  PatchSispekAccount,
} from '@/api/cems'
import { mapState } from 'vuex'

export default Vue.extend({
  data() {
    return {
      optsAPIVersion: [
        { text: 'V1', value: 'V1' },
        { text: 'V2', value: 'V2' },
      ],

      stacks: [] as Stack[],
      account: {} as SispekAccount,

      company: {
        name: '',
        address: '',
        telephone: '',
        sispekServer: '',
        appId: '',
        appSecret: '',
      } as Company,
      testRunning: false,

      showAccountInformationAllert: false,
    }
  },
  computed: {
    ...mapState('license', { license: 'detailLicense' }),
  },
  methods: {
    async getCompany() {
      this.company = await GetCompany()
    },
    async patchCompany() {
      await PatchCompany(this.company.id, this.company)
    },
    async testConnection() {
      this.testRunning = true
      try {
        const { status, message } = await SISPEKConnectionTest()
        if (status) {
          this.$toast.success(message)
        } else {
          this.$toast.error(message)
        }
      } catch (e) {
        // this.$toast.error('Something wrong. See console for more information')
        // eslint-disable-next-line
        console.log(e)
      }

      setTimeout(() => {
        this.testRunning = false
      }, 1000)
    },

    async findStacks() {
      this.stacks = await FindStacks(['Sispek'])
    },

    async getAccount() {
      this.account = await GetSispekAccount()
    },

    async patchAccount() {
      this.account = await PatchSispekAccount(this.account)
    },

    // ------------------------------------------------------------------------------
    // Keyboard & mouse Events
    // ------------------------------------------------------------------------------
    async onFormSubmit(e: Event) {
      e.preventDefault()
      await this.patchAccount()
    },

    onRowClick(stack: Stack) {
      this.$router.push(`/cems/setting/chimney/${stack.uid}/sispek`)
    },

    // allert
    disableAccountAllert() {
      localStorage.setItem('sispek_DAA', '1')
      this.getAccountAllert()
    },

    enableAccountAllert() {
      localStorage.removeItem('sispek_DAA')
      this.getAccountAllert()
    },

    getAccountAllert() {
      const sispekDAA = localStorage.getItem('sispek_DAA')
      this.showAccountInformationAllert = sispekDAA == null
    },
  },
  async created() {
    this.getAccountAllert()
    await this.getCompany()
    await this.findStacks()
    await this.getAccount()
  },
})
